import { render } from "./HelpItem.vue?vue&type=template&id=61ff801f"
import script from "./HelpItem.vue?vue&type=script&lang=js"
export * from "./HelpItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__